import { Controller } from "stimulus";
import { showElement, hideElement } from "controllers/utilities/display.js";

export default class extends Controller {
  static targets = [
    "momoRadio",
    "bankCardRadio",
    "alizzaRadio",
    "boaRadio",
    "paymentRadios",
    "paymentsOptions",
    "momoForm",
    "bankCardForm",
    "alizzaForm",
    "boaForm",
    "momoFormTitle",
    "bankCardFormTitle",
    "alizzaFormTitle",
    "boaFormTitle",
    "feesMessage",
    "fees",
    "totalAmount",
    "totalAmountCurrencyLabel",
    "amount",
    "feesContainer",
    "amountInput",
    "amountErrorMessage",
    "amanataForm",
    "amanataPhone",
    "amanataPhoneErrorMessage",
    "amanataPendingStep",
    "amanataPhoneCountry",
    "amanataFormTitle",
    "amanataPendingStepForm",
    "myNitaForm",
    "myNitaPhone",
    "myNitaPhoneErrorMessage",
    "myNitaPendingStep",
    "myNitaPhoneCountry",
    "myNitaFormTitle",
    "myNitaCodeValidation",
    "momoPhone",
    "momoPhoneErrorMessage",
    "momoPhoneCountry",
    "momoImages",
    "momoPendingMessage",
    "cardPhone",
    "cardPhoneErrorMessage",
    "cardCountry",
    "cardPageButton",
    "pan",
    "panErrorMessage",
    "exp",
    "expErrorMessage",
    "cvv",
    "cvvErrorMessage",
    "data3dsUrl",
    "alizzaPhone",
    "alizzaPhoneErrorMessage",
    "alizzaPhoneCountry",
    "boaPhone",
    "boaPhoneErrorMessage",
    "boaPhoneCountry",
    "alizzaPublicReference",
    "boaPublicReference",
    "name",
    "nameErrorMessage",
    "button",
    "paymentSuccess",
    "paymentFailed",
    "paymentNotification",
    "paymentNotificationContent",
    "step",
    "momoPendingStep",
    "formStep",
    "currentResponseStep",
    "cardPendingStep",
    "alizzaPendingStep",
    "boaPendingStep",
    "3dsFrameStep",
    "card3dsStep",
    "data3dsForm",
    "data3dsPaReq",
    "data3dsMd",
    "nitaOnlineForm",
    "nitaOnlineFormTitle",
    "nitaOnlinePhoneErrorMessage",
    "nitaOnlinePhone",
    "nitaOnlinePendingStep",
    "nitaOnlineCodeValidation",
    "nitaOnlinePhoneCountry",
    "corisMoneyRadio",
    "corisMoneyForm",
    "corisMoneyFormTitle",
    "corisMoneyPhone",
    "corisMoneyPhoneCountry",
    "corisMoneyPhoneErrorMessage",
    "corisMoneyOtpStep",
    "corisMoneyOtp",
    "corisMoneyOtpMessage",
    "corisMoneyOtpErrorMessage",
    "corisMoneyOtpButton",
  ];

  static values = {
    objectId: String,
    objectClass: String,
    publicKey: String,
    maxAmount: Number,
    momoFees: Number,
    bankCardFees: Number,
    amanataFees: Number,

    myNitaFees: Number,
    myNitaFeesOnClient: Boolean,

    nitaOnlineFees: Number,
    nitaOnlineFeesOnClient: Boolean,

    corisMoneyFees: Number,
    corisMoneyFeesOnClient: Boolean,

    boaFees: Number,
    alizzaFees: Number,
    momoFeesOnClient: Boolean,
    bankCardFeesOnClient: Boolean,
    amanataFeesOnClient: Boolean,
    boaFeesOnClient: Boolean,
    alizzaFeesOnClient: Boolean,
    paymentReference: String,
    fixedAmount: Boolean,
    hasIframeParent: Boolean,
    parentDomaine: String,
    transactionId: String,
    onSuccessRedirectionUrl: String,
    onFailedRedirectionUrl: String,
  };

  connect() {
    this.MTN_BJ_MSISDN = /^229(01)?(97|96|91|90|69|67|66|62|61|54|53|52|51|42)/;
    this.MOOV_BJ_MSISDN = /^229(99|98|95|94|65|64|55)/;
    this.MOOV_NE_MSISDN = /^227(74|75|84|85|94|95)/;
    this.AIRTEL_NE_MSISDN = /^227(96|97|98|99|87|88|89|86|76|77)/;
    this.ZAMANI_NE_MSISDN = /^227(70|80|81|90|91|92)/;
    this.selectedProvider = null;
    this.paymentMethod = null;
    this.amount = this.fixedAmountValue ? this.maxAmountValue : 0;
    this.name = this.hasNameTarget ? this.nameTarget.value : "";
    if (this.hasMomoFormTarget) this.momoPhone = this.momoPhoneTarget.value;
    if (this.hasBankCardFormTarget) {
      this.cardPhone = this.cardPhoneTarget.value;
      this.countryCode = "NE";
      this.cardCountry = "227";
      this.pan = this.panTarget.value;
      this.exp = this.expTarget.value;
      this.cvv = this.cvvTarget.value;

      this.panInputOldValue;
      this.panInputOldCursor;
      this.isValidatedPan = false;
      this.expInputOldValue;
      this.isValidatedExp = false;
      this.cvvInputOldValue;
      this.isValidatedCvv = false;
    }
    if (this.hasAlizzaFormTarget)
      this.alizzaPhone = this.alizzaPhoneTarget.value;
    if (this.hasBoaFormTarget) this.boaPhone = this.boaPhoneTarget.value;
    if (this.hasAmanataFormTarget)
      this.amanataPhone = this.amanataPhoneTarget.value;
    if (this.hasMyNitaFormTarget)
      this.myNitaPhone = this.myNitaPhoneTarget.value;
    if (this.hasNitaOnlineFormTarget)
      this.nitaOnlinePhone = this.nitaOnlinePhoneTarget.value;
    if (this.hasCorisMoneyFormTarget)
      this.corisMoneyPhone = this.corisMoneyPhoneTarget.value;
    this.paymentReference = "";
    this.bankCardPageUrl = "";

    this.switchPaymentMethod();
    if (this.hasFeesMessageTarget) {
      this.updateAmountDatainUI();
    }

    document.addEventListener("payment:succeed", this.updatePayment.bind(this));
  }

  displayForm(e) {
    this.changePaymentMethod(e);
    hideElement(this.paymentsOptionsTarget);
    showElement(this.formStepTarget);
  }

  backToOptions() {
    showElement(this.paymentsOptionsTarget);
    hideElement(this.formStepTarget);
  }

  switchPaymentMethod() {
    if (this.hasFeesContainerTarget) this.showFeesContainer();

    const methods = {
      momo: {
        form: "momoFormTarget",
        title: "momoFormTitleTarget",
      },
      bankCard: {
        form: "bankCardFormTarget",
        title: "bankCardFormTitleTarget",
      },
      alizza: {
        form: "alizzaFormTarget",
        title: "alizzaFormTitleTarget",
      },
      boa: {
        form: "boaFormTarget",
        title: "boaFormTitleTarget",
      },
      amanata: {
        form: "amanataFormTarget",
        title: "amanataFormTitleTarget",
      },
      myNita: {
        form: "myNitaFormTarget",
        title: "myNitaFormTitleTarget",
      },
      nitaOnline: {
        form: "nitaOnlineFormTarget",
        title: "nitaOnlineFormTitleTarget",
      },
      corisMoney: {
        form: "corisMoneyFormTarget",
        title: "corisMoneyFormTitleTarget",
      },
    };

    // Hide all forms and titles
    Object.values(methods).forEach(({ form, title }) => {
      if (this[`has${capitalize(form)}`]) hideElement(this[form]);
      if (this[`has${capitalize(title)}`]) hideElement(this[title]);
    });

    // Show selected method
    const selected = methods[this.paymentMethod];
    if (selected) {
      showElement(this[selected.form]);
      showElement(this[selected.title]);
    }

    function capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  }

  showFeesContainer() {
    hideElement(this.feesContainerTarget);

    if (this._getFeesOnClient()) {
      showElement(this.feesContainerTarget);
    }
  }

  updateAmountDatainUI() {
    const fees = this._getFees();
    if (fees == 0) {
      hideElement(this.feesMessageTarget);
    } else {
      showElement(this.feesMessageTarget);
    }

    this.feesTarget.textContent = fees;

    this.totalAmountTarget.textContent = this._getFeesOnClient()
      ? Math.ceil(this.amount + (this.amount * fees) / 100)
      : this.amount;
    if (this.hasTotalAmountCurrencyLabelTarget) {
      this.totalAmountCurrencyLabelTarget.textContent = "F CFA";
    }
  }

  amountChanged(e) {
    hideElement(this.amountErrorMessageTarget);

    const inputVal = parseFloat(this.amountInputTarget.value) || 0;
    this.amount = Math.round(inputVal);

    if (
      this.amount <= 0 ||
      (this.maxAmountValue > 0 && this.amount > this.maxAmountValue)
    ) {
      showElement(this.amountErrorMessageTarget);
    }

    this.updateAmountDatainUI();
  }

  nameChanged(e) {
    hideElement(this.nameErrorMessageTarget);

    this.name = this.nameTarget.value.trim();

    if (this.name == "") {
      showElement(this.nameErrorMessageTarget);
    }
  }

  momoPhoneChanged() {
    hideElement(this.momoPhoneErrorMessageTarget);
    this.momoImagesTargets.forEach((img) => {
      img.classList.add("blanc");
      img.classList.remove("selected");
    });

    this.momoPhone = this.momoPhoneTarget.value.trim();
    var msisdnCode = this.momoPhoneCountryTarget.value == "NE" ? "227" : "229";
    var momoPhone = msisdnCode + this.momoPhone;

    if (this.momoPhone === "") {
      showElement(this.momoPhoneErrorMessageTarget);
    } else {
      this._updateMomoImages(momoPhone);
    }
  }

  amanataPhoneChanged(e) {
    hideElement(this.amanataPhoneErrorMessageTarget);

    this.amanataPhone = this.amanataPhoneTarget.value.trim();

    if (this.amanataPhone == "") {
      showElement(this.amanataPhoneErrorMessageTarget);
    }
  }

  myNitaPhoneChanged(e) {
    hideElement(this.myNitaPhoneErrorMessageTarget);

    this.myNitaPhone = this.myNitaPhoneTarget.value.trim();

    if (this.myNitaPhone == "") {
      showElement(this.myNitaPhoneErrorMessageTarget);
    }
  }

  nitaOnlinePhoneChanged(e) {
    hideElement(this.nitaOnlinePhoneErrorMessageTarget);
    this.nitaOnlinePhone = this.nitaOnlinePhoneTarget.value.trim();

    if (this.nitaOnlinePhone == "") {
      showElement(this.nitaOnlinePhoneErrorMessageTarget);
    }
  }

  corisMoneyPhoneChanged(e) {
    hideElement(this.corisMoneyPhoneErrorMessageTarget);
    this.corisMoneyPhone = this.corisMoneyPhoneTarget.value.trim();

    if (this.corisMoneyPhone == "") {
      showElement(this.corisMoneyPhoneErrorMessageTarget);
    }
  }

  staPhoneChanged(e) {
    let type = e.target.dataset.type;
    hideElement(this[`${type}PhoneErrorMessageTarget`]);
    this[`${type}Phone`] = this[`${type}PhoneTarget`].value.trim();

    if (this[`${type}Phone`] == "") {
      showElement(this[`${type}PhoneErrorMessageTarget`]);
    }
  }

  cardPhoneChanged(e) {
    hideElement(this.cardPhoneErrorMessageTarget);

    this.cardPhone = this.cardPhoneTarget.value.trim();

    if (this.cardPhone == "") {
      showElement(this.cardPhoneErrorMessageTarget);
    }
  }

  cardCountryChanged(e) {
    const countryCodeArray = this.cardCountryTarget.value.split(" "); // split at space
    this.cardCountry = countryCodeArray[0];
    this.countryCode = countryCodeArray[1];
  }

  panChanged(e) {
    this._validePan();
    let panPattern = /^\d{0,16}$/g,
      separator = " ",
      unMarkedPan = this._unmask(this.panTarget.value),
      newCursorPosition;

    if (unMarkedPan.match(panPattern)) {
      unMarkedPan = this._mask(unMarkedPan, 4, separator);

      newCursorPosition =
        this.panInputOldCursor -
        this._checkSeparator(this.panInputOldCursor, 4) +
        this._checkSeparator(
          this.panInputOldCursor +
          (unMarkedPan.length - this.panInputOldValue.length),
          4,
        ) +
        (this._unmask(unMarkedPan).length -
          this._unmask(this.panInputOldValue).length);

      this.panTarget.value = unMarkedPan !== "" ? unMarkedPan : "";
      this.pan = this.panTarget.value;
      this.isValidatedPan = true;
      this._validePan();
    } else {
      this.isValidatedPan = false;
      this._validePan();
      this.panTarget.value = this.panInputOldValue;
      newCursorPosition = this.panInputOldCursor;
    }

    this.panTarget.setSelectionRange(newCursorPosition, newCursorPosition);
  }

  expChanged(e) {
    this._valideExp();
    let expPattern = /^\d{0,4}$/g,
      expSeparator = "/",
      unMarkedExp = this._unmask(this.expTarget.value);

    if (unMarkedExp.match(expPattern)) {
      unMarkedExp = this._mask(unMarkedExp, 2, expSeparator);
      this.expTarget.value = unMarkedExp;
      this.exp = this.expTarget.value;
      this.isValidatedExp = true;
      this._valideExp();
    } else {
      this.expTarget.value = this.expInputOldValue;
      this.isValidatedExp = false;
      this._valideExp();
    }
  }

  cvvChanged(e) {
    this._valideCvv();
    let cvvPattern = /^\d{0,3}$/g,
      unMarkedCvv = this._unmask(this.cvvTarget.value);

    if (unMarkedCvv.match(cvvPattern)) {
      this.cvv = this.cvvTarget.value;
      this.isValidatedCvv = true;
      this._valideCvv();
    } else {
      this.cvvTarget.value = this.cvvInputOldValue;
      this.isValidatedCvv = false;
      this._valideCvv();
    }
  }

  panInputKeyDownHandler(e) {
    let el = e.target;
    this.panInputOldValue = el.value;
    this.panInputOldCursor = el.selectionEnd;
  }

  expInputKeyDownHandler(e) {
    let el = e.target;
    this.expInputOldValue = el.value;
  }

  cvvInputKeyDownHandler(e) {
    let el = e.target;
    this.cvvInputOldValue = el.value;
  }

  changePaymentMethod(e) {
    this.paymentMethod = e.target.value;
    this.switchPaymentMethod();
    this.updateAmountDatainUI();
  }

  resquestPayment(e) {
    if (this._hasBasicErrors()) return;

    switch (this.paymentMethod) {
      case "momo":
        this._requestMomoPayment();
        break;
      case "bankCard":
        this._requestBankCardPayment();
        break;
      case "alizza":
        this._requestStaPayment("alizza");
        break;
      case "boa":
        this._requestStaPayment("boa");
        break;
      case "amanata":
        this._requestAmanataPayment();
        break;
      case "myNita":
        this._requestMyNitaPayment();
        break;
      case "nitaOnline":
        this._requestNitaOnlinePayment();
        break;
      case "corisMoney":
        this._requestCorisMoneyPayment();
        break;
    }
  }

  updatePayment(e) {
    if (this.paymentReference != e.detail.reference) {
      return;
    }

    const status = e.detail.status;
    const data = e.detail.otherData;
    const reference = e.detail.reference;
    const msisdn = data.msisdn;
    const amount = data.amount;
    const externalReference = data.externalReference;

    if (this.hasIframeParentValue) {
      parent.postMessage(
        { type: "payment.response", other: data },
        this.parentDomaineValue,
      );
    }

    if (status == "succeeded") {
      this.paymentSuccessTarget.setAttribute(
        "id",
        `payment_success_${reference}`,
      );

      if (this.onSuccessRedirectionUrlValue) {
        const reference = externalReference.split("_")[0];
        this._redirectAfterPayment(
          `${this.onSuccessRedirectionUrlValue}?reference=${reference}&transaction_id=${externalReference}&msisdn=${msisdn}&status=${status}&amount=${amount}`,
        );
      }

      this._displayStep("currentResponseStep");
    }

    if (status == "failed") {
      this.paymentFailedTarget.setAttribute(
        "id",
        `payment_failed_${reference}`,
      );

      if (this.onFailedRedirectionUrlValue) {
        const reference = externalReference.split("_")[0];
        this._redirectAfterPayment(
          `${this.onFailedRedirectionUrlValue}?reference=${reference}&transaction_id=${externalReference}&msisdn=${msisdn}&status=${status}&amount=${amount}`,
        );
      }

      this._displayStep("currentResponseStep");
    }
  }

  openPaymentPage() {
    var url = this.cardPageButtonTarget.dataset.url;
    window.open(
      `${url}/orabank_payment_page/?payment_reference=${this.paymentReference}&page_url=${this.bankCardPageUrl}`,
      "_blank",
    );
    this._displayStep("cardPendingStep");
  }

  closeServerMessage() {
    hideElement(this.paymentNotificationTarget);
  }

  _validateMSISDN(momoPhone) {
    return (
      this.MTN_BJ_MSISDN.test(momoPhone) ||
      this.MOOV_BJ_MSISDN.test(momoPhone) ||
      this.MOOV_NE_MSISDN.test(momoPhone) ||
      this.AIRTEL_NE_MSISDN.test(momoPhone) ||
      this.ZAMANI_NE_MSISDN.test(momoPhone)
    );
  }

  _updateMomoImages(momoPhone) {
    if (this.MTN_BJ_MSISDN.test(momoPhone)) this.selectedProvider = "MTN_BJ";
    else if (this.MOOV_BJ_MSISDN.test(momoPhone))
      this.selectedProvider = "MOOV_BJ";
    else if (this.MOOV_NE_MSISDN.test(momoPhone))
      this.selectedProvider = "MOOV_NE";
    else if (this.AIRTEL_NE_MSISDN.test(momoPhone))
      this.selectedProvider = "AIRTEL_NE";
    else if (this.ZAMANI_NE_MSISDN.test(momoPhone))
      this.selectedProvider = "ZAMANI_NE";

    if (this.selectedProvider) {
      this.momoImagesTargets.forEach((img) => {
        if (img.dataset.provider === this.selectedProvider) {
          img.classList.remove("blanc");
          img.classList.add("selected");
        }
      });
    }
  }

  _requestMomoPayment() {
    const phoneCountry = this.momoPhoneCountryTarget.value;
    const msisdnCode = phoneCountry == "NE" ? "227" : "229";

    this._submitPayment("mobile", {
      country: phoneCountry,
      currency: "XOF",
      msisdn: msisdnCode + this.momoPhone.replace(/\s+/g, ""),
      payment_option: "mobile"
    }, () => {
      if (this.selectedProvider === "ZAMANI_NE") {
        this.momoPendingMessageTarget.innerHTML = "Taper <b>#146#</b> pour valider la transaction.";
      }
      this._displayStep("momoPendingStep");
    });
  }

  _requestAmanataPayment() {
    const phoneCountry = this.amanataPhoneCountryTarget.value;
    const msisdnCode = phoneCountry == "NE" ? "227" : "229";

    this._submitPayment("amanata", {
      country: phoneCountry,
      currency: "XOF",
      msisdn: msisdnCode + this.amanataPhone,
      payment_option: "amanata"
    }, () => {
      this._displayStep("amanataPendingStep");
    });
  }

  _requestMyNitaPayment() {
    const phoneCountry = this.myNitaPhoneCountryTarget.value;
    const msisdnCode = { NE: "227", BJ: "229" }[phoneCountry];
    if (!msisdnCode) throw new Error(`Unsupported country code: ${phoneCountry}`);

    this._submitPayment("my_nita", {
      country: phoneCountry,
      currency: "XOF",
      msisdn: msisdnCode + this.myNitaPhone.replace(/\s+/g, ""),
      payment_option: "myNita"
    }, (response) => {
      this._displayStep("myNitaPendingStep");
      this.myNitaCodeValidationTarget.textContent = response.meta_data.code;
    });
  }

  _requestNitaOnlinePayment() {
    const phoneCountry = this.nitaOnlinePhoneCountryTarget.value;
    const msisdnCode = { NE: "227", BJ: "229" }[phoneCountry];
    if (!msisdnCode) throw new Error(`Unsupported country code: ${phoneCountry}`);

    this._submitPayment("nita_online", {
      country: phoneCountry,
      currency: "XOF",
      msisdn: msisdnCode + this.nitaOnlinePhone.replace(/\s+/g, ""),
      payment_option: "nita_online"
    }, (response) => {
      this._displayStep("nitaOnlinePendingStep");
      this.nitaOnlineCodeValidationTarget.textContent = response.meta_data.code;
    });
  }

  _requestCorisMoneyPayment() {
    if (this.corisMoneyPhone == "") {
      showElement(this.corisMoneyPhoneErrorMessageTarget);
      return;
    }

    this._submitPayment("coris_money", {
      country: "NE",
      currency: "XOF",
      msisdn: "227" + this.corisMoneyPhone.replace(/\s+/g, ""),
      payment_option: "coris_money"
    }, (response) => {
      if (response.meta_data && response.meta_data.otp_required) {
        this._displayStep("corisMoneyOtpStep");
        this.corisMoneyOtpTarget.focus();
      } else {
        showElement(this.paymentNotificationTarget);
        this.paymentNotificationContentTarget.textContent =
          "Impossible d'initier le paiement Coris Money, veuillez réessayer";
      }
    });
  }

  // Coris Money: submit the OTP received by SMS. The final status still
  // reaches the page through the payer-stream broadcast (updatePayment).
  validateCorisMoneyOtp(e) {
    if (e) e.preventDefault();

    const secretCode = this.corisMoneyOtpTarget.value.replace(/\s+/g, "");
    hideElement(this.corisMoneyOtpErrorMessageTarget);
    if (!/^\d{4,6}$/.test(secretCode)) {
      this._showCorisMoneyOtpError("Veuillez saisir le code reçu par SMS");
      return;
    }

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Ipay-Target-Environment", "live");
    headers.append("Ipay-Payment-Type", "coris_money");
    headers.append("Authorization", `Bearer ${this.publicKeyValue}`);

    this.corisMoneyOtpButtonTarget.classList.add("is-loading");

    fetch(`/api/sdk/v1/payments/${this.paymentReference}/otp_validation`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ secret_code: secretCode }),
    })
      .then((response) => response.json())
      .then((response) => {
        this.corisMoneyOtpButtonTarget.classList.remove("is-loading");

        switch (response.outcome) {
          case "succeeded":
          case "processing":
            this.corisMoneyOtpButtonTarget.disabled = true;
            this.corisMoneyOtpTarget.disabled = true;
            this.corisMoneyOtpMessageTarget.textContent =
              "Paiement en cours de finalisation, veuillez patienter...";
            break;
          case "retry":
            this.corisMoneyOtpTarget.value = "";
            this._showCorisMoneyOtpError(
              `${response.message} (${response.attempts_left} tentative(s) restante(s))`,
            );
            break;
          default:
            this.corisMoneyOtpButtonTarget.disabled = true;
            this._showCorisMoneyOtpError(
              response.message || "Le paiement a échoué",
            );
        }
      })
      .catch((error) => {
        this.corisMoneyOtpButtonTarget.classList.remove("is-loading");
        this._showCorisMoneyOtpError("Une erreur est survenue, veuillez réessayer");
        console.log(error, "error");
      });
  }

  _showCorisMoneyOtpError(message) {
    this.corisMoneyOtpErrorMessageTarget.textContent = message;
    showElement(this.corisMoneyOtpErrorMessageTarget);
  }

  _requestBankCardPayment() {
    if (this._hasBankCardErrors()) return;

    this._submitPayment("card", {
      country: this.cardCountry,
      currency: "XOF",
      msisdn: this.countryCode + this.cardPhoneTarget.value.replace(/\s+/g, ""),
      payment_option: "card",
      pan: this._unmask(this.pan),
      exp: this.exp,
      cvv: this.cvv,
    }, (response) => {
      if (response.state == "AWAIT_3DS") {
        this._sendBrowserInfo(response);
      }
    }, "/api/sdk/v1/payments/bank_card_payment");
  }

  _sendBrowserInfo(response) {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Ipay-Target-Environment", "live");
    myHeaders.append("Ipay-Payment-Type", "card");
    myHeaders.append("Authorization", `Bearer ${this.publicKeyValue}`);

    var raw = JSON.stringify({
      reference: response.reference,
      order_reference: response.order_reference,
      payment_reference: response.payment_reference,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };

    fetch("/api/sdk/v1/payments/send_device_information", requestOptions)
      .then((response) => {
        if (response.ok) {
          response.json().then((response) => {
            this._toggleButtonLoading();
            if (response.state == "AWAIT_3DS") {
              this.data3dsUrlTarget.src = `${response.term_url_get}?acs_url=${response.acs_url}&base64_encoded_cqeq=${response.base64_encoded_cqeq}&challenge_notification_url=${response.notification_url}`;
              this._displayStep("card3dsStep");
            }
          });
        } else {
          response.json().then((response) => {
            this._toggleButtonLoading();
            console.warn("iPay payment error:", response.message, response.errors);
            showElement(this.paymentNotificationTarget);
            this.paymentNotificationContentTarget.textContent =
              this._responseErrorMessage(response.message, response.code);
          });
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  }
  _requestStaPayment(type) {
    const phoneCountry = this[`${type}PhoneCountryTarget`].value;
    const msisdnCode = phoneCountry == "NE" ? "227" : "229";

    this._submitPayment("sta", {
      country: phoneCountry,
      currency: "XOF",
      msisdn: msisdnCode + this[`${type}Phone`].replace(/\s+/g, ""),
      payment_option: "sta"
    }, (response) => {
      this.paymentReference = response.reference;
      this[`${type}PublicReferenceTarget`].textContent = response.public_reference;
      this._displayStep(`${type}PendingStep`);
    });
  }

  _submitPayment(type, extraParams, successCallback, url = "/api/sdk/v1/payments") {
    if (this._hasBasicErrors()) return;

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Ipay-Target-Environment", "live");
    myHeaders.append("Ipay-Payment-Type", type);
    myHeaders.append("Authorization", `Bearer ${this.publicKeyValue}`);

    var raw = JSON.stringify({
      amount: this.amount,
      transaction_id: this.transactionIdValue || Date.now(),
      customer_name: this.name,
      item_id: this.objectIdValue,
      item_type: this.objectClassValue,
      ...extraParams
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };

    this._toggleButtonLoading();

    fetch(url, requestOptions)
      .then((response) => {
        if (response.ok) {
          response.json().then((response) => {
            this._toggleButtonLoading();
            this.paymentReference = response.reference;
            if (successCallback) successCallback(response);
          });
        } else {
          response.json().then((response) => {
            this._toggleButtonLoading();
            console.warn("iPay payment error:", response.message, response.errors);
            showElement(this.paymentNotificationTarget);
            this.paymentNotificationContentTarget.textContent =
              this._responseErrorMessage(response.message, response.code);
          });
        }
      })
      .catch((error) => {
        this._toggleButtonLoading();
        console.log(error, "error");
      });
  }

  _hasBasicErrors() {
    hideElement(this.nameErrorMessageTarget);
    hideElement(this.amountErrorMessageTarget);

    let error = false;
    if (this.name == "") {
      showElement(this.nameErrorMessageTarget);
      error = true;
    }
    if (this.amount == 0) {
      showElement(this.amountErrorMessageTarget);
      error = true;
    }
    return error;
  }

  _hasBankCardErrors() {
    if (this._hasBasicErrors()) return true;

    hideElement(this.cardPhoneErrorMessageTarget);
    hideElement(this.panErrorMessageTarget);
    hideElement(this.expErrorMessageTarget);
    hideElement(this.cvvErrorMessageTarget);

    if (this.cardPhone == "") {
      showElement(this.cardPhoneErrorMessageTarget);
      return true;
    }
    if (this.pan == "" || !this.isValidatedPan) {
      this._validePan();
      return true;
    }
    if (this.exp == "" || !this.isValidatedExp) {
      this._valideExp();
      return true;
    }
    if (this.cvv == "" || !this.isValidatedCvv) {
      this._valideCvv();
      return true;
    }
    return false;
  }

  _getFees() {
    const paymentMethodMap = {
      momo: this.momoFeesValue,
      bankCard: this.bankCardFeesValue,
      alizza: this.alizzaFeesValue,
      boa: this.boaFeesValue,
      amanata: this.amanataFeesValue,
      nitaOnline: this.nitaOnlineFeesValue,
      corisMoney: this.corisMoneyFeesValue,
    };
    return paymentMethodMap[this.paymentMethod] || 0;
  }

  _getFeesOnClient() {
    const feesOnClientMap = {
      momo: this.momoFeesOnClientValue,
      bankCard: this.bankCardFeesOnClientValue,
      alizza: this.alizzaFeesOnClientValue,
      boa: this.boaFeesOnClientValue,
      amanata: this.amanataFeesOnClientValue,
      nitaOnline: this.nitaOnlineFeesOnClientValue,
      corisMoney: this.corisMoneyFeesOnClientValue,
    };
    return feesOnClientMap[this.paymentMethod] || false;
  }

  _displayStep(step) {
    this.stepTargets.forEach((elt) => elt.classList.add("is-hidden"));
    this[`${step}Target`].classList.remove("is-hidden");
  }

  _toggleButtonLoading() {
    this.buttonTarget.classList.toggle("is-loading");
  }

  _mask(value, limit, separator) {
    var output = [];
    for (let i = 0; i < value.length; i++) {
      if (i !== 0 && i % limit === 0) {
        output.push(separator);
      }

      output.push(value[i]);
    }

    return output.join("");
  }

  _unmask(value) {
    return value.replace(/[^\d]/g, "");
  }

  _checkSeparator(position, interval) {
    return Math.floor(position / (interval + 1));
  }

  _validePan() {
    if (this.pan == "") {
      this.panErrorMessageTarget.textContent = "Le pan doivent être remplis";
      showElement(this.panErrorMessageTarget);
      return;
    }

    if (!this.isValidatedPan) {
      this.panErrorMessageTarget.textContent = "Format incorrect";
      showElement(this.panErrorMessageTarget);
      return;
    }

    hideElement(this.panErrorMessageTarget);
  }

  _valideExp() {
    if (this.exp == "") {
      this.expErrorMessageTarget.textContent =
        "La date d'expiration doit être rempli";
      showElement(this.expErrorMessageTarget);
      return;
    }

    if (!this.isValidatedExp) {
      this.expErrorMessageTarget.textContent = "Format incorrect";
      showElement(this.expErrorMessageTarget);
      return;
    }

    if (this.exp.slice(0, 2) > 12) {
      this.expErrorMessageTarget.textContent = "Invalid mois";
      showElement(this.expErrorMessageTarget);
      return;
    }

    if (
      this.exp.slice(3, 5) < new Date().getFullYear().toString().slice(2, 4)
    ) {
      this.expErrorMessageTarget.textContent = "Carte expirer";
      showElement(this.expErrorMessageTarget);
      return;
    }

    hideElement(this.expErrorMessageTarget);
  }

  _valideCvv() {
    if (this.cvv == "") {
      this.cvvErrorMessageTarget.textContent = "Le cvv doit être rempli";
      showElement(this.cvvErrorMessageTarget);
      return;
    }

    if (!this.isValidatedExp) {
      this.cvvErrorMessageTarget.textContent = "Format incorrect";
      showElement(this.cvvErrorMessageTarget);
      return;
    }

    hideElement(this.cvvErrorMessageTarget);
  }

  _responseErrorMessage(message, code) {
    var error;
    switch (code || message) {
      case "Bad Request: Missing Body Params":
        error = "Paramètres manquants";
        break;
      case "Bad Request: Country Not Allowed":
        error = "Pays non autorisé";
        break;
      case "Bad Request: Currency Not Allowed":
        error = "Devise non autorisée";
        break;
      case "Bad Request: Amount Not Valid":
        error = "Montant non valide";
        break;
      case "Bad Request: Incorrect MSISDN":
        error = "Numéro incorrect";
        break;
      case "Bad Request: Missing MyNita Account":
        error = "Compte MyNita non trouvé pour ce numéro";
        break;
      case "Bad Request: Payment Method Not Available":
        error = "Moyen de paiement non disponible";
        break;
      case "external_reference_taken":
        error = "Cette commande a déjà été traitée ou est en cours. Actualisez la page ou contactez le marchand";
        break;
      case "external_reference_invalid":
        error = "Référence de commande invalide. Contactez le marchand";
        break;

      default:
        error = "Une erreur est survenue, veuillez réessayer";
    }
    return error;
  }

  _redirectAfterPayment(redirectUrl) {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }
}
